/*
 *  I10DIAEFCOLReducer.ts
 *
 *  Created by Node Generator on Sun Aug 10 2025 19:21:38 GMT+0200 (Central European Summer Time)
 *  Copyright © 2025 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I10DIAEFCOL_State } from '@batical/types/src'

const I10DIAEFCOL: I10DIAEFCOL_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  res_vitesseSilMax: 0,
  coeffMajoration: 'ecs1',
  in_evier: 0,
  in_lavabo: 0,
  in_bidet: 0,
  in_baignoire: 0,
  in_douche: 0,
  in_robinetdemi: 0,
  in_robinetquart: 0,
  in_lavemain: 0,
  in_baclaver: 0,
  in_linge: 0,
  in_vaiselle: 0,
  tube_uuid: '3950E368-DDA7-451A-A349-F3A5B13B5452',
  canalisationdebit_uuid: 'cnn3',
  res_debitBase: 0,
  res_coeffSimul: 0,
  res_debitProbable: 0,
  res_diamIntRecommande: 0,
  res_debit_max_prob: 0,
  res_vitesseReelle: 0,
  res_diamConforme: '',
  mode: 'none',
  calcul_code: 'I10DIAEFCOL'
}

export default I10DIAEFCOL
